require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};